import { createSelector } from 'reselect';

const selectPrograms = (state: any) => state.programs;


export const selectProgramsCurrentItem = createSelector([selectPrograms], (programs) => programs.current);

export const selectProgramsListItems = createSelector([selectPrograms], (programs) => programs.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectProgramsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectProgramsQueryItems = createSelector([selectPrograms], (programs) => programs.query);

export const selectProgramsCreatedItem = createSelector([selectPrograms], (programs) => programs.create);

export const selectProgramsUpdatedItem = createSelector([selectPrograms], (programs) => programs.update);

export const selectProgramsReadItem = createSelector([selectPrograms], (programs) => programs.read);

export const selectProgramsDeletedItem = createSelector([selectPrograms], (programs) => programs.delete);

export const selectProgramsSearchedItems = createSelector([selectPrograms], (programs) => programs.search);

export const selectProgramsItemsCount = createSelector([selectPrograms], (programs) => programs.count);

export const selectProgramsItemsFilter = createSelector([selectPrograms], (programs) => programs.filter);